import { Component, OnDestroy, OnInit, ViewChild, NgZone, AfterViewInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormControl } from "@angular/forms";

import {
    implementsTKeys,
    TCI_APP_FEATURE_TYPE,
    USER_ROLES,
    TCI_COMPONENT_MODE,
    TCI_APP_CUSTOMIZATION_TYPE,
    TCI_APP_DEPLOYMENT_STAGE,
    ITCIApplication,
    ITCITenantAppCategory,
    ITCIApplicationDeleteRequest,
    ITCIApplicationDeleteResponse,
    ITCIApplicationDeploymentProvider,
    ITCIValidationResult,
    ITCIApplicationCreateProvider,
    ITCIApplicationCreateRequest,
    ITCIApplicationCreateResponse,
    ITCIAppCustomizationParam,
    ITCIApplicationDeployRequest,
    TCIApplicationCreateOption,
    TCITenantAppDetailsMenu,
    TCITenantAppType,
    TCITenantAppCategory,
    TCIActionState,
    TCITenantSelectorType,
    TCIAppDeploymentCategory,
    TCIMainMenu,
    TCIMainMenuSubroutes,
    ITCIAssetTag,
    ITCIAssetTagsList,
    ITCITenantComponentOptions,
    TCI_APP_DETAIL_MENU_TYPE,
    TCIStatusFilterCategory,
    ITCIStatusFilterCategory,
    mapIServiceToTenantAppType,
    ITCIMetricsStatus,
    TCIMetricsLabelType,
    ITCIApplicationDeployResponse,
    TCI_TENANT_SERVICE_PROVIDER_TYPE, TCITenantModalType
} from "@tci/common";

import {NgTagsService} from "../../ng-shared/ng-services/ng-tags.service";
import {NgAppListHeaderComponent} from "../ng-app-list-header/ng-app-list-header.component";
import {BaseAppDetailMenuComponentInput} from "../../ng-app-details/ng-app-details-menu";
import {IAppCreationResponse} from "../ng-app-create-v2/ng-app-create-v2.component";
import {NgAppListService} from "../ng-app-list.service";
import {NgToastrService} from "../../ng-shared/ng-components/ng-toastr/ng-toastr.service";
import {TciTenantService} from "../../ng-tenant/tci-tenant.service";
import {TciTenantModelService} from "../../ng-tenant/tci-tenant.model";
import {TCITenantRemoteServices} from "../../ng-tenant/tci-tenant-remote-services";
import {ITCIAppDetailsMenuOutput} from "../../ng-tenant/tci-tenant-components";
import {TCITenantMenuServices} from "../../ng-tenant/tci-tenant.menu";
import {NgUserService} from "../../ng-shared/ng-services/ng-user.service";
import {NgWaitService} from "../../ng-shared/ng-components/ng-wait/ng-wait.service";
import {NgCustomizationProviderService} from "../../ng-shared/ng-services/ng-customization-provider.service";
import {NgAppFeatureToggleService} from "../../ng-shared/ng-services/ng-app-feature-toggle.service";
import { NgToolsService } from "../../ng-shared/ng-util/ng-tools.service";
import { NgAppDeployService } from "../../ng-app-deploy/ng-app-deploy.service";
import { NgAppChangeNotificationService } from "../../ng-shared/ng-services/ng-app-change-notification.service";
import { NgAppHMService } from "../../ng-app-hamburger-menu/ng-app-hamburger-menu.service";
import { ITCITenantCacheOptions, TciTenantComponentCacheService, ITCITenantCompCache } from "../../ng-tenant/tci-tenant-component-cache.service";
import { NgAppListHeaderService } from "../ng-app-list-header/ng-app-list-header.service";

import { NgPaginatorComponent } from "../../ng-shared/ng-components/ng-paginator/ng-paginator.component";
import {
    routeChildReduce,
    getCategoryFilterOptions,
    getAppDeploymentFilterOptions,
    getAppStatusFilterOptions,
    ICategoryFilterOptions,
    setTimeoutInZone
} from "../../ng-shared/ng-util/tools";

import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject, Observable, Observer, ReplaySubject, Subscription } from "rxjs";
import { Dialog } from "primeng/primeng";
import * as CryptoJS from "crypto-js";
import * as lodash from "lodash";
import { Http } from "@angular/http";

const FILTER_LABEL_ALL = "All";

const GAL_SORTABLE_ROWS = {
    CATEGORY: "category",
    NAME: "name",
    DEPLOYMENT_TYPE: "appDeploymentType",
    LAST_MODIFIED: "modifiedTime",
    LAST_RUN: "lastRunTime"
};

const GAL_LOCAL_ITEM = "TCI-GAL-LOCAL-DATA";
const GAL_LOCAL_ITEM_PREFIX = "tci_gal_";
const GAL_LOCAL_MONITOR_ITEM = "GAL_LOCAL_MONITOR_ITEM";
const GAL_LOCAL_MONITOR_ITEM_PREFIX = "tci_mon_";

interface IStoredFilterAndPagination {
    filter: { category: string, deploymentCategory: string, statusCategory: string, name: string, owner: string, tags: ITCIAssetTag[] };
    sort: { column: string, asc: boolean };
    page: number;
}

interface ICreateAppInfo {
    success: boolean;
    canCreateRes: boolean | ITCIValidationResult;
    createProvider: ITCIApplicationCreateProvider;
    input: ITCIApplicationCreateRequest;
    createRes: ITCIApplicationCreateResponse;
    nameInfo: { name: string };
    validation: ITCIValidationResult;
    errors: string[];
}

@Component({
    selector: "ng-app-listing",
    templateUrl: "./ng-app-listing.component.html",
    styleUrls: ["./ng-app-listing.component.css"]
})
export class NgAppListingComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild("pager") pager: NgPaginatorComponent;
    @ViewChild("dialogCreateApp") dialogCreateApp: Dialog;
    @ViewChild("dialogDeleteApp") dialogDeleteApp: Dialog;

    subscriptions: Subscription[] = [];

    createDialog: number[];
    apps: ITCIApplication[];
    requestingApps = true;
    appsExist: boolean;

    private createAppModalShow = false;
    private createDialogAppModal: { tenantType: TCITenantAppType, width: number } = {
        tenantType: <TCITenantAppType>null,
        width: 0
    };

    private deleteAppModalShow = false;
    private deleteAppInfo: ITCIApplication;
    private isBeingDeleted: { [key: string]: boolean } = {};
    private deleteAppIsPublished: boolean;
    confirmedAppName = "";

    // enable create/import option for ROR users
    private canShowCreateButton = false;

    // Filter handlers
    private filteredApps: ITCIApplication[] = [];
    private categoryFilter: string = FILTER_LABEL_ALL;
    private appDeploymentCategoryFilter: string = FILTER_LABEL_ALL;
    private appStatusCategoryFilter: string = FILTER_LABEL_ALL;
    private nameFilterCtrl = new FormControl();
    private FILTER_CATEGORIES: ICategoryFilterOptions[] = [];
    private FILTER_APP_DEPLOY_CATEGORY: ICategoryFilterOptions[] = [];
    private FILTER_APP_STATUS_CATEGORY: ICategoryFilterOptions[] = [];

    private FILTER_OWNER = { ANY: "ANY", OWNED: "OWNED" };
    private ownerFilter: string = this.FILTER_OWNER.ANY;
    private ownerCounter = { ANY: 0, OWNED: 0 };
    private ownerName: string;

    // Status filter
    private appStatusMap: Record<string, ITCIStatusFilterCategory> = {};
    private isMetricsDataAvailable = false;
    private appStatusFilterEnabled = false;

    // Pagination
    private pageStart = 0;
    private pages = 10;
    private paginatedRows$: BehaviorSubject<ITCIApplication[]> = new BehaviorSubject([]);
    private pageRestoreValue: number; // GAL Stage restoration

    // Sorting
    private SORTABLE_ROWS = GAL_SORTABLE_ROWS;
    private sortedBy: string = GAL_SORTABLE_ROWS.LAST_RUN;
    private sortAsc = false;

    // Status Menu
    statusMenuApp: ITCIApplication;
    private statusMenuOptRouteId: string;
    private statusMenuSelectedOption: TCITenantAppDetailsMenu;
    private statusMenuCmpInput: BaseAppDetailMenuComponentInput;

    // App server errors
    appServerErrors: string[] = [];

    // Deployment Providers
    private tenantProviders: { [key: string]: ITCIApplicationDeploymentProvider } = {};

    // Custom Configs
    private CUSTOM_TYPES = TCI_APP_CUSTOMIZATION_TYPE;
    private customConfig: { [key: string]: ITCIAppCustomizationParam } = {};
    private createBtnLabel = "";

    // Monitoring
    monitorEnabled: boolean;
    monitorPanelActive = false;
    private monitorComponent: NgAppListHeaderComponent;
    monitorPanelUseTransition = true;
    private monitorPanelRestored = false;

    // Deploy confirmation dialogs
    deployConfirmIsAliveShow = false;
    deployConfirmIsAliveShowInput: ITCIApplicationDeployRequest;

    // FLOGO-6175
    loadingCreateModules = false;

    // Asset tags
    tagsList: ITCIAssetTagsList;
    tagsListSubject$: ReplaySubject<ITCIAssetTagsList> = new ReplaySubject<ITCIAssetTagsList>(1);
    allAssetTags: ITCIAssetTag[] = [];
    allAssetTagsCount = 0;
    selectedTags: ITCIAssetTag[] = [];
    selectedTagsCount = 0;
    tagsFilterVisible = false;

    // IPAS-15720 - Do not update pagination on delete
    private updatePagination = true;

    constructor(
        private AppsAPIService: NgAppListService,
        private tenantSvc: TciTenantService,
        private tenantModelSvc: TciTenantModelService,
        private tenantMenuSrv: TCITenantMenuServices,
        private cacheSvc: TciTenantComponentCacheService,
        private toastrSvc: NgToastrService,
        private tenantRemoteServices: TCITenantRemoteServices,
        private router: Router,
        private route: ActivatedRoute,
        private userService: NgUserService,
        private blockUiService: NgWaitService,
        private customizationProviderService: NgCustomizationProviderService,
        private translateSvc: TranslateService,
        private featureToggleService: NgAppFeatureToggleService,
        private ngToolsSvc: NgToolsService,
        private appDeplSvc: NgAppDeployService,
        private appRefreshNotifSvc: NgAppChangeNotificationService,
        private tagsService: NgTagsService,
        private hmSvc: NgAppHMService,
        private ngZone: NgZone,
        private headerSvc: NgAppListHeaderService,
        private http: Http
    ) {
        // Catch child event parameters for Status Menu Options
        this.subscriptions.push(
            router.events
                .subscribe((evnt: any) => {
                    if (evnt.state && (evnt.state.root || evnt.state._root)) {
                        const root = evnt.state.root || evnt.state._root;

                        // Do not react when navigating to app-details
                        if (!root.firstChild.url[1] || root.firstChild.url[1].path !== "details") {
                            const routeParams = lodash.assign({}, routeChildReduce(root));
                            this.statusMenuRouteHandling(routeParams["routeid"], routeParams["inputid"]);
                        }
                    }
                }),

            route.queryParams
                .subscribe(qParams => {
                    if (qParams.mode && this.apps.length > 0) {
                        alert("Recommendations are displayed only if no apps are present");
                        this.router.navigate(["applications"]);
                    }
                }),

            // Features
            this.featureToggleService.getAppFeatures()
                .subscribe(res => {
                    this.monitorEnabled = res[TCI_APP_FEATURE_TYPE.APP_MONITORING].enabled;
                    this.appStatusFilterEnabled = res[TCI_APP_FEATURE_TYPE.APP_STATUS_FILTER].enabled;
                }),

            // FE Custom Config Setup
            this.getCustomConfig()
                .subscribe(() => {
                    this.getCustomLabel(this.CUSTOM_TYPES.APP_CREATE).subscribe(label => this.createBtnLabel = label);
                    this.userService.getUserInfo()
                        .finally(() => this.requestAppsAndTags())
                        .subscribe((userInfo) => this.ownerName = userInfo.userId);
                }),

            this.appDeplSvc.getDialogRequestSubj()
                .subscribe(req => {
                    this.deployConfirmIsAliveShowInput = req;
                    this.deployConfirmIsAliveShow = true;
                }),

            this.getTenantProviders()
                .subscribe(tenantProviders => {
                    this.tenantProviders = tenantProviders;
                    console.log("Tenant Providers", this.tenantProviders);
                }),

            this.userService.getUserInfo()
                .subscribe(token => this.canShowCreateButton = token.rolX[0] === USER_ROLES.RO),

            // Get the tags
            this.AppsAPIService.getTagsSaveSubject()
                .subscribe(tagsIsBusy => {
                    if (!tagsIsBusy && this.apps) {
                        this.requestTags();
                    }
                })
        );


        // Get the apps
        this.checkAppsExist();

        /* Code to handle pendo guide event apptype submit */
        document.addEventListener("pendo-submit", (data: any) => {
            this.router.navigate(["applications"], { queryParams: { mode: data.detail } });
        });
    }

    ngOnInit() {
        /**
         * This is only for external liveapps notification until we see that it is good for other app types
         */
        this.appRefreshNotifSvc.getRefreshSubject()
            .filter(refr => refr.app.type && TCITenantAppType.liveapps.equals(refr.app.type))
            .subscribe(() => {
                this.requestAppsAndTags();
            });
        this.createDialog = [TCITenantModalType.TCI_MODAL_CREATE_DIALOG.getWidth(), TCITenantModalType.TCI_MODAL_CREATE_DIALOG.getHeight()];
    }

    ngAfterViewInit() {
        this.subscriptions.push(
            // get selected status event from app monitoring dashbord
            this.headerSvc.getStatusFilterSubject()
                .subscribe(status => {
                    const category = TCIStatusFilterCategory.fromLabel(status.name);
                    this.filterByAppStatusCategory(category, this.getStatusFilterCount(category));
                }),
            // get refresh event from app monitoring dashbord
            this.headerSvc.getDashboardRefSub()
                .subscribe(res => {
                    if (res.refresh) {
                        this.createAppStatusMap().subscribe(() => this.updateFilters());
                    }
                }),
            this.appRefreshNotifSvc.getRefreshSubject()
                .subscribe(res => {
                    this.createAppStatusMap().subscribe(() => this.updateFilters());
                })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());

        const typeGroup = this.getDeployerProvidersGroup(this.filteredApps);
        Object
            .keys(typeGroup)
            .forEach(type => {
                typeGroup[type].forEach(appId => this.tenantProviders[type].stopStatusSubscription(appId));
            });
    }

    refreshAppList() {
        this.requestAppsAndTags();
    }

    private requestAppsAndTags() {
        /**
         * This way the UI Blocker would be shown only if
         * the app list request takes more than "showTime"
         */
        const showTime = 350;
        this.ngToolsSvc.setTimeout(() => {
            if (this.requestingApps) {
                this.blockUiService.block("Loading...");
            }
        }, showTime);

        // If customizers require tags
        const tagsReq: Observable<ITCIAssetTagsList> = this.getCustomVisible(this.CUSTOM_TYPES.APP_LIST_FILTER_TAGS) ?
            this.tagsService.getAllTags() : Observable.of({ tags: [] });

        // Request tags and apps
        Observable.combineLatest(
            tagsReq,
            this.AppsAPIService.getApps(),
            (tags, apps) => ({ tags, apps })
        ).finally(() => {
            // Await for apps to be set at the header component
            setTimeoutInZone(this.ngZone, this.restoreMonitoringExpandState.bind(this), 0);
        })
            .subscribe(
                data => {
                    const appServerErrors = data.apps.filter(app => app.error).map(app => app.error);
                    if (appServerErrors.length > 0) {
                        console.error("There are problems getting all applications", appServerErrors);
                        this.appServerErrors = appServerErrors.map(error => error.message);
                    }

                    this.apps = data.apps.filter(app => !app.error);
                    const localStorageKey = this.getGALPrefForUsr(this.ownerName);
                    const GALstageData = localStorage.getItem(localStorageKey); // Restore filters, sort and pagination
                    if (!lodash.isEmpty(GALstageData)) {
                        try {
                            const GALstage: IStoredFilterAndPagination = JSON.parse(GALstageData);

                            // Restore sort
                            this.sortedBy = GALstage.sort.column;
                            this.sortAsc = GALstage.sort.asc;

                            this.pageRestoreValue = GALstage.page; // Restore pagination

                            if (!lodash.isEmpty(GALstage.filter.name)) { // Restore filter by name
                                this.nameFilterCtrl.setValue(GALstage.filter.name);
                            }

                            // Restore filter by category and owner
                            this.ownerFilter = lodash.isEmpty(GALstage.filter.owner) ? this.FILTER_OWNER.ANY : GALstage.filter.owner;
                            const category = GALstage.filter.category;
                            const appCategory = TCITenantAppCategory.fromId(category);
                            const deploymentCategory = GALstage.filter.deploymentCategory;
                            const appDeploymentCategory = TCIAppDeploymentCategory.fromId(deploymentCategory);
                            const statusCategory = GALstage.filter.statusCategory;
                            const appStatusCategory = TCIStatusFilterCategory.fromId(statusCategory);
                            const isFilterCategory = category !== FILTER_LABEL_ALL
                                && !lodash.isUndefined(appCategory) && !lodash.isEmpty(appCategory);
                            const isFilterDeploymentCategory = deploymentCategory !== FILTER_LABEL_ALL
                                && !lodash.isUndefined(appDeploymentCategory) && !lodash.isEmpty(appDeploymentCategory);
                            const isFilterStatusCategory = statusCategory !== FILTER_LABEL_ALL
                                && !lodash.isUndefined(appStatusCategory) && !lodash.isEmpty(appStatusCategory);
                            if (isFilterCategory || isFilterDeploymentCategory || isFilterStatusCategory) {
                                if (isFilterCategory) {
                                    this.filterByCategory(appCategory);
                                }
                                if (isFilterDeploymentCategory) {
                                    this.filterByAppDeploymentCategory(appDeploymentCategory);
                                }
                                if (isFilterStatusCategory) {
                                    this.filterByAppStatusCategory(appStatusCategory, this.getStatusFilterCount(appStatusCategory));
                                }
                            }
                        } catch (e) {
                            console.error("GAL stage restore incomplete", e);
                        }
                    }
                    this.subscriptions.push(
                        this.createAppStatusMap().subscribe(() => this.updateFilters())
                    );
                    this.updateFilterAppCounter();
                    this.requestTags(data.tags); // This will trigger filtering

                    // Initialize name filtering actions
                    this.nameFilterCtrl.valueChanges
                        .debounceTime(300)
                        .subscribe(() => this.filterApps());

                    // Capture initial route params
                    Observable.merge(...this.route.children.map(child => child.params))
                        .subscribe(obj => {
                            const routeParams = lodash.assign({}, obj);
                            this.statusMenuRouteHandling(routeParams["routeid"], routeParams["inputid"]);
                        }).unsubscribe();
                },
                err => console.error("Error requesting apps", err)
            );
    }

    private checkAppsExist() {
        this.appsExist = this.AppsAPIService.appsExist();
    }

    private getTenantProviders(): Observable<{ [key: string]: ITCIApplicationDeploymentProvider }> {
        return this.tenantModelSvc.onInit()
            .map(() => {
                const tenantProviders: { [key: string]: ITCIApplicationDeploymentProvider } = {};
                const tenants = this.tenantModelSvc.getTenants();
                Object
                    .keys(tenants)
                    .forEach(tenantName => {
                        tenantProviders[tenantName] = tenants[tenantName].getAppDeploymentProvider();
                    });
                return tenantProviders;
            });
    }

    /**
     * <App Create instructions>
     */
    private createApp() { // Toggle action for FE
        this.loadingCreateModules = true;
        const loadGALModules = () => {
            return this.tenantSvc.onInit()
                .map(() => this.tenantModelSvc.getTenants())
                .flatMap(tenants => {
                    // Compile the apps-list modules for all the tenants
                    const obs: Observable<ITCITenantCompCache>[] = [];
                    for (const i in tenants) {
                        if (tenants[i]) {
                            const opts: ITCITenantCacheOptions = {
                                routeId: TCIMainMenu.MAIN_MENU_APPLICATIONS.getRouteId(),
                                subRouteId: TCIMainMenuSubroutes.TCI_APPLICATION_APP_LIST.getSubRouteId(),
                                tenantType: tenants[i].getTenantType()
                            };

                            obs.push(this.cacheSvc.getCache(false, opts));
                        }
                    }
                    return Observable.merge(...obs)
                        .toArray()
                        .map(() => tenants); // Return the tenants collection for the next flatMap
                });
        };

        const custom = this.customConfig[this.CUSTOM_TYPES.APP_CREATE];
        if (custom && custom.enabled && custom.tenantCustomization) {
            this.blockUiService.block("Creating app...");
            const responseData: IAppCreationResponse = {
                solution: { type: null },
                response: {
                    appId: null,
                    name: null,
                    success: true
                }
            };

            const collectedData: ICreateAppInfo = {
                success: true,
                canCreateRes: null,
                createProvider: null,
                input: null,
                createRes: null,
                nameInfo: null,
                validation: null,
                errors: null
            };

            loadGALModules()
                .flatMap(tenants => {
                    for (const i in tenants) {
                        if (tenants[i]) {
                            // Check what tenant is providing the customization config. It can only be one.
                            const tenantCustomProvider = tenants[i].getAppCustomizationProvider();
                            if (tenantCustomProvider) {
                                const createProvider = tenants[i].getAppCreateProvider();
                                if (createProvider) {
                                    // Look for default create option
                                    collectedData.createProvider = createProvider;
                                    const create_option = TCIApplicationCreateOption.getDefaultOption(tenants[i].getTenantType());
                                    if (create_option) {
                                        collectedData.input = {
                                            create_option,
                                            tenantType: tenants[i].getTenantType()
                                        };
                                        responseData.solution.type = collectedData.input.tenantType;
                                        return createProvider.canCreate(collectedData.input)
                                            .map(canCreateRes => {
                                                collectedData.canCreateRes = canCreateRes;
                                                return collectedData;
                                            });
                                    } else {
                                        collectedData.success = false;
                                        collectedData.errors = ["Create application default option not available"];
                                        return Observable.of(collectedData);
                                    }
                                } else {
                                    collectedData.success = false;
                                    collectedData.errors = ["Create application provider not available"];
                                    return Observable.of(collectedData);
                                }
                            }
                        }
                    }
                })
                .map(res => {
                    if (res.success) {
                        if (implementsTKeys<ITCIValidationResult>(
                            res.canCreateRes,
                            [
                                "errors",
                                "setError",
                                "getErrors",
                                "state"
                            ]
                        )) {
                            const errors = res.canCreateRes.getErrors();
                            if (res.canCreateRes.state !== TCIActionState.TCI_ACTION_OK && errors.length > 0) { // CanCreate invalid
                                res.errors = errors.map(err => err.getErrorMessage());
                            } else {
                                return res;
                            }
                        } else if (lodash.isEqual(res.canCreateRes, true)) { // CanCreate valid
                            return res;
                        }

                        // Error if no valid state found
                        res.success = false;
                        res.errors = [`Tenant provider "canCreate" return block action`];
                    }
                    return res;
                })
                .flatMap(res => { // Get the new app name
                    if (res.success) {
                        return this.AppsAPIService.getAppName(res.input.tenantType)
                            .catch(err => {
                                const errMsg = "Could not get new app name";
                                console.error(errMsg, err);
                                res.errors = [errMsg];
                                res.success = false;
                                return Observable.of(null);
                            })
                            .map(nameInfo => {
                                res.nameInfo = nameInfo;
                                return res;
                            });
                    } else {
                        return Observable.of(res);
                    }
                })
                .flatMap(res => { // Validate with name
                    if (res.success) {
                        res.input.name = res.nameInfo.name;
                        return res.createProvider.validate(res.input)
                            .map(val => {
                                res.validation = val;
                                return res;
                            });
                    } else {
                        return Observable.of(res);
                    }
                })
                .flatMap(res => { // Evaluate validation result
                    if (res.success) {
                        if (res.validation.state === TCIActionState.TCI_ACTION_OK) {
                            return res.createProvider.createApplication(res.input)
                                .map(createRes => {
                                    res.createRes = createRes;
                                    return res;
                                });
                        } else {
                            res.success = false;
                            res.errors = res.validation.getErrors().map(err => err.getErrorMessage());
                            return Observable.of(res);
                        }
                    } else {
                        return Observable.of(res);
                    }
                })
                .subscribe(
                    res => {
                        if (res.success) {
                            // IMPORTANT: This solution do not cover Warnings listing
                            if (res.createRes.success) {
                                if (res.createRes.warnings && res.createRes.warnings.errors.length > 0) {
                                    console.warn(
                                        "AppCreate thrown some warnings",
                                        res.createRes.warnings.getErrors().map(err => err.getErrorMessage())
                                    );
                                }
                                this.toastrSvc.success(`${res.createRes.name} application`, "has been created");
                                responseData.response.appId = res.createRes.appId;
                                responseData.response.name = res.createRes.name;
                                responseData.response.success = res.createRes.success;
                                this.appCreateSucceed(responseData);
                            } else {
                                responseData.response.msg = res.errors.join(", ");
                                responseData.response.success = false;
                                this.appCreateFailed(responseData);
                            }

                        } else {
                            console.error("The application could not be created", res);
                            responseData.response.msg = res.errors.join(", ");
                            responseData.response.success = false;
                            this.appCreateFailed(responseData);
                        }
                    },
                    err => {
                        const errMsg = "The application could not be created";
                        console.error(errMsg, err);
                        responseData.response.msg = errMsg;
                        responseData.response.success = false;
                        this.appCreateFailed(responseData);
                    }
                );
        } else {
            this.createAppModalShow = true;
            loadGALModules().subscribe();
        }
    }

    private appCreateStart() {
        this.blockUiService.block("Creating a new application...");
        this.toastrSvc.clear();
    }

    private appCreateSucceed(res: IAppCreationResponse) {
        this.AppsAPIService.getAppById(res.response.appId, res.solution.type) // Get information of the new app
            .map(app => this.AppsAPIService.getAppDetailsRoute(app))
            .subscribe(appDetailsLink => {
                this.router.navigate(appDetailsLink.route, {
                    queryParams: appDetailsLink.queryParams,
                    relativeTo: this.route
                });
            });
    }

    private appCreateFailed(res: IAppCreationResponse) {
        this.blockUiService.unblock();
        // Note: when success is false and error msg is not empty, should not close create dialog.
        // ...or when there are warnings/errors
        const isShowDialog = res && res.response && !res.response.success &&
            (
                res.response.msg !== "" ||
                res.response.warnings.getErrors().length > 0 ||
                res.response.warnings.getWarnings().length > 0
            );

        this.createDialogAppModalClose(isShowDialog);
        console.error("App creation failed", res);
    }

    private appCreateEnd() {
        this.blockUiService.unblock();
        this.createDialogAppModalClose();
    }

    private appCreateEndWithWarnings() {
        this.blockUiService.unblock();
    }

    private createDialogAppModalClose(isShowDialog: boolean = false) {
        delete this.createDialogAppModal.tenantType;
        this.createAppModalShow = isShowDialog;
        this.loadingCreateModules = false;
        this.toastrSvc.clear();
    }

    /**
     * </ App Create instructions>
     *
     * <App Delete instructions>
     */
    private deleteAppChoose(app: ITCIApplication) {
        this.deleteAppInfo = app;
        this.deleteAppModalShow = true;
        this.deleteAppIsPublished = app && app.publishStage === TCI_APP_DEPLOYMENT_STAGE.PUBLISHED;
        this.toastrSvc.clear();
    }

    private deleteApp() {
        const appId = this.deleteAppInfo.id;
        this.isBeingDeleted[appId] = true;

        // Build tenant provider data
        this.tenantSvc.onInit().subscribe(() => {
            const tenant = this.tenantModelSvc.getTenant(this.deleteAppInfo.type);
            if (tenant) {
                const appData: ITCIApplicationDeleteRequest = {
                    application: this.deleteAppInfo,
                    appId,
                    tenantType: this.deleteAppInfo.type
                };
                const provider = tenant.getAppDeleteProvider();
                const errorCallback = (info = "This app is not able to be deleted at this moment") => {
                    this.toastrSvc.error(`App was not deleted ${this.deleteAppInfo.name}`, info);
                    this.requestAppsAndTags();

                };
                this.subscriptions.push(
                    provider.canDeleteApplication(appData)
                        .flatMap(canDelete => {
                            if (canDelete) {
                                return provider.deleteApplication(appData);
                            } else {
                                return Observable.of(<ITCIApplicationDeleteResponse>{
                                    appId: appData.appId,
                                    msg: "This app is not able to be deleted at this moment",
                                    success: false
                                });
                            }
                        })
                        .finally(() => {
                            this.isBeingDeleted[appId] = false;

                            // Refresh monitoring panel
                            // if (this.monitorPanelActive) {
                            // Await for apps to be set at the header component
                            // setTimeoutInZone(this.ngZone, () => { this.monitorComponent.refresh(); }, 0);
                            // }
                        })
                        .subscribe(
                            delRes => {
                                if (delRes.success) {
                                    // Remove the app from collection at once, but restore app list if error
                                    [this.apps, this.filteredApps].forEach(
                                        collection => collection.splice(collection.findIndex(app => app.id === appId), 1)
                                    );
                                    this.updatePagination = false;
                                    this.AppsAPIService.decreaseAppsCount();
                                    this.checkAppsExist();
                                    this.setPaginatedRows();
                                    this.updateFilterAppCounter();
                                    this.requestTags();
                                    // Trigger refresh request for dashboard to update the data after app delete.
                                    this.appRefreshNotifSvc.requestRefresh(
                                        this.deleteAppInfo,
                                        undefined,
                                        TCI_TENANT_SERVICE_PROVIDER_TYPE.APP_DELETE
                                    );
                                    this.toastrSvc.success(this.deleteAppInfo.name, "The application has been deleted successfully");
                                } else {
                                    errorCallback(delRes.msg);
                                }
                            },
                            error => {
                                errorCallback(`Error: ${error.msg}`);
                                console.error(`"${this.deleteAppInfo.name}" app could not be deleted`, error);
                            }
                        )
                );
            } else {
                console.error("No delete provider available");
            }
        });

        this.deleteAppModalShow = false;
    }

    private deleteCancel() {
        this.deleteAppInfo = undefined;
        this.deleteAppModalShow = false;
        this.confirmedAppName = "";
    }

    // App Deployer Handler instructions
    private getDeployerProvidersGroup(apps: ITCIApplication[]): { [key: string]: ITCIApplication[] } {
        const typeGroup = apps.reduce((retVal, app) => {
            const appType = app.type.toString();
            (retVal[appType] = retVal[appType] || []).push(app);
            return retVal;
        }, {});

        Object
            .keys(typeGroup)
            .forEach(type => {
                if (lodash.isEmpty(this.tenantProviders[type])) {
                    delete typeGroup[type];
                }
            });

        return typeGroup;
    }

    /**
     * </App Delete instructions>
     *
     * <List filtering instructions>
     */
    private updateFilterAppCounter() {
        this.AppsAPIService.getRemoteServices()
            .map(remoteSrv => remoteSrv.map(srv => TCITenantAppType.fromString(srv.name).toString()))
            .subscribe(remoteSrv => {
                this.FILTER_CATEGORIES = getCategoryFilterOptions(FILTER_LABEL_ALL)
                    .map(filterOpt => {
                        if (filterOpt.category.id === FILTER_LABEL_ALL) {
                            filterOpt.counter = this.apps.length;
                        } else {
                            filterOpt.counter = this.apps
                                .filter(app => remoteSrv.includes(app.type.toString()))
                                .filter(app => TCITenantAppCategory.fromApplication(app).id === filterOpt.category.id)
                                .length;
                        }
                        return filterOpt;
                    })
                    .filter(opt => opt.counter > 0);  // Filter by application existence;

                this.FILTER_APP_DEPLOY_CATEGORY = getAppDeploymentFilterOptions(FILTER_LABEL_ALL)
                    .map(filterOpt => {
                        if (filterOpt.category.id === FILTER_LABEL_ALL) {
                            filterOpt.counter = this.apps.length;
                        } else {
                            filterOpt.counter = this.apps
                                .filter(app => remoteSrv.includes(app.type.toString()))
                                .filter(app => TCIAppDeploymentCategory.fromOnPremise(app).id === filterOpt.category.id)
                                .length;
                        }
                        return filterOpt;
                    })
                    .filter(opt => opt.counter > 0);  // Filter by application existence;

                this.FILTER_APP_STATUS_CATEGORY = getAppStatusFilterOptions(FILTER_LABEL_ALL)
                    .map(filterOpt => {
                        if (filterOpt.category.id === FILTER_LABEL_ALL) {
                            filterOpt.counter = this.apps.length;
                        } else {
                            filterOpt.counter = this.apps
                                .filter(app => remoteSrv.includes(app.type.toString()))
                                .filter(app =>
                                    this.appStatusMap[app.id] && this.appStatusMap[app.id].id === filterOpt.category.id
                                )
                                .length;
                        }
                        return filterOpt;
                    });
                // Owner filter counter
                // Include all scribe apps in owned filter also as owner value is null
                this.ownerCounter.ANY = this.apps.length;
                this.ownerCounter.OWNED = this.apps
                    .filter(app => remoteSrv.includes(app.type.toString()))
                    .filter(app => app.owner === this.ownerName || app.owner === null)
                    .length;
            });
    }
    /**
     *
     * @param category
     * @returns status filter count
     */
    private getStatusFilterCount(category: ITCIStatusFilterCategory): number {
        const filter = this.FILTER_APP_STATUS_CATEGORY.filter(_cat => _cat.category === category);
        return filter.length ? filter[0].counter : 0;
    }

    private updateFilters() {
        /**
         * Adding status feature enable check to avoid any side effects from app change or
         * dashboard refresh events incase feature is in disabled state.
         */
        if (this.appStatusFilterEnabled) {
            this.updatePagination = false;
            this.updateFilterAppCounter();
            this.filterApps();
        }
    }

    /**
     * Creates a map of appId's and corresponding app status from metrics API.
     * @returns void
     */
    private createAppStatusMap() {
        const tenantsObs$ = this.AppsAPIService.getRemoteServices()
                .flatMap(svcs => svcs)
                .map(svc => mapIServiceToTenantAppType(svc))
                .distinct(svc => svc.toString())
                .toArray();

        const getMetrics$ = this.headerSvc.getMetrics();

        return Observable.combineLatest(getMetrics$, tenantsObs$, (metrics, tenantTypes) => (
            { metrics, tenantTypes }
        ))
            .catch(err => Observable.of(null))
            .map(res => {
                const filter = (data: ITCIMetricsStatus) =>
                        TCITenantAppType.fromString(data.labels.app_type).appliesTo(res.tenantTypes);

                const createMap = (data: ITCIMetricsStatus[], app: ITCIApplication) => {
                    data.map(_app => {
                        if (_app.labels &&
                            Array.isArray(_app.labels.app_ids) &&
                            _app.labels.app_ids.length &&
                            _app.labels.app_ids.includes(app.id)
                        ) {
                            this.appStatusMap[app.id] = TCIStatusFilterCategory.fromMetricsStatus(_app.labels.status);
                        }
                    });
                };
                if (res) {
                    this.apps.map(app => {
                        try {
                            const metricsData = (res.metrics.labeledOrgMetrics[TCIMetricsLabelType.tci_apps] || [])
                                .filter(data => filter(data));
                            const onPremMetricsData = (res.metrics.labeledOrgMetrics[TCIMetricsLabelType.tci_onpremise_apps] || [])
                                .filter(data => filter(data));
                            this.isMetricsDataAvailable = metricsData.concat(onPremMetricsData).length > 0;

                            if (metricsData.length) {
                                createMap(metricsData, app);
                            }
                            if (onPremMetricsData.length) {
                                createMap(onPremMetricsData, app);
                            }
                        } catch (err) {
                            console.error("Error parsing metrics data : ", err);
                        }
                    });
                }
                return null;
            });
    }

    private filterApps() {
        const filterMakeup = (f: string) => f.toString().toLowerCase().trim();
        this.filteredApps = this.apps
            .filter(app =>
                this.categoryFilter === FILTER_LABEL_ALL ||
                TCITenantAppCategory.fromApplication(app).id === this.categoryFilter
            )
            .filter(app =>
                this.appDeploymentCategoryFilter === FILTER_LABEL_ALL ||
                TCIAppDeploymentCategory.fromOnPremise(app).id === this.appDeploymentCategoryFilter
            )
            .filter(app =>
                /**
                 * This allows app list to conitune loading when we are in process of applying status filter from local storage
                 * and waiting for the api response.
                 */
                !this.isMetricsDataAvailable ||
                this.appStatusCategoryFilter === FILTER_LABEL_ALL ||
                (this.appStatusMap[app.id] && this.appStatusMap[app.id].id === this.appStatusCategoryFilter)
            )
            .filter(app =>
                lodash.isEmpty(this.nameFilterCtrl.value) ||
                filterMakeup(app.name).indexOf(filterMakeup(this.nameFilterCtrl.value)) >= 0
            )
            .filter(app =>
                lodash.isEmpty(this.selectedTags) ||
                lodash.intersectionBy(app.tags, this.selectedTags, "name").length > 0
            );

        if (this.ownerFilter === this.FILTER_OWNER.OWNED) {
            // Include all scribe apps in owned filter also as owner value is null
            this.filteredApps = this.filteredApps.filter(app => app.owner === this.ownerName || app.owner === null);
        }

        if (this.tagsList) {
            this.countAppsPerTag();
        }

        if (this.updatePagination && this.pager) { // Reset the paginator current page
            this.pager.changePage(this.pageRestoreValue || 1);
            delete this.pageRestoreValue;
        } else {
            this.updatePagination = true; // Reset the flag
        }

        this.sort(this.sortedBy || GAL_SORTABLE_ROWS.CATEGORY);
    }

    private filterByCategory(opt: ITCITenantAppCategory) {
        const filteredCategory: string = opt.id === FILTER_LABEL_ALL ? FILTER_LABEL_ALL : opt.id;
        if (this.categoryFilter !== filteredCategory) {
            this.categoryFilter = filteredCategory;
            this.filterApps();
        }
    }

    private filterByAppDeploymentCategory(opt: ITCITenantAppCategory) {
        const filteredCategory: string = opt.id === FILTER_LABEL_ALL ? FILTER_LABEL_ALL : opt.id;
        if (this.appDeploymentCategoryFilter !== filteredCategory) {
            this.appDeploymentCategoryFilter = filteredCategory;
            this.filterApps();
        }
    }

    private filterByAppStatusCategory(opt: ITCIStatusFilterCategory, filterCount?: number) {
        const filteredCategory: string = opt.id === FILTER_LABEL_ALL ? FILTER_LABEL_ALL : opt.id;
        if (this.appStatusCategoryFilter !== filteredCategory) {
            this.appStatusCategoryFilter = filteredCategory;
            /**
             * Since we are not resetting pagination when applying status filter on app change or dashboard refresh events
             * in method updateFilters(), pageRestoreValue might still exist. Hence, checking and clearing it on status filter
             * change so that pagination is reset to page 1.
             */
            if (this.pageRestoreValue) {
                delete this.pageRestoreValue;
            }
            // Dont call metrics api if Filter_All is selected or filter count is 0.
            if (filteredCategory === FILTER_LABEL_ALL || filterCount === 0) {
                this.filterApps();
            } else {
                this.subscriptions.push(
                    this.createAppStatusMap().subscribe(() => this.filterApps())
                );
            }
        }
    }

    private filterByOwner(ownerFilter: string) {
        this.ownerFilter = ownerFilter;
        this.filterApps();
    }

    private resetFilters($event: MouseEvent) {
        $event.stopPropagation();
        this.categoryFilter = FILTER_LABEL_ALL;
        this.ownerFilter = this.FILTER_OWNER.ANY;
        this.appDeploymentCategoryFilter = FILTER_LABEL_ALL;
        this.appStatusCategoryFilter = FILTER_LABEL_ALL;
        this.nameFilterCtrl.setValue("");
        this.selectedTags = [];
        this.filterApps();
    }

    /**
     * </List filtering instructions>
     *
     * <Paginator instructions>
     */
    private setPaginatedRows() {
        const part = this.filteredApps.slice(this.pageStart, this.pageStart + this.pages);
        if (part) {
            if (part.length === 0 && this.pager) { // Deleted app from last page, "pager" could be gone if no app is present after filtering
                const prevPage = this.pager.getPage() - 1;
                if (prevPage > 0) {
                    this.pager.changePage(prevPage);
                }
            } else {
                this.paginatedRows$.next(part);
            }
        }
        this.storeGALstage();
    }

    private onPageChange($event: number) {
        this.pageStart = $event;
        this.setPaginatedRows();
    }

    /**
     * </Paginator instructions>
     *
     * <Sorting instructions>
     */
    sort(sortBy: string) {
        if (sortBy === GAL_SORTABLE_ROWS.CATEGORY) {
            this.sortByCatUtil(true);
        }

        // Sort straight first
        // IPAS-13258: Sorts in case sensitive order (ASCII sort) instead of using default sort.
        if (sortBy === GAL_SORTABLE_ROWS.NAME) {
            this.filteredApps = this.filteredApps.sort((a, b) => this.alphaNumSort(a.name.toString(), b.name.toString())).reverse();
        } else {
            this.filteredApps = lodash.sortBy(this.filteredApps, sortBy, "type.val", GAL_SORTABLE_ROWS.NAME).reverse();
        }
        this.sortByCatUtil(false);

        if (this.sortAsc) { // If sorting is ASC then reverse
            this.filteredApps.reverse();
        }
        this.setPaginatedRows();
    }

    toggleSort(sortBy: string) {
        this.sortAsc = !this.sortAsc;

        if (sortBy === GAL_SORTABLE_ROWS.CATEGORY) {
            this.sortByCatUtil(true);
        }

        this.sortedBy = sortBy;
        if (sortBy === GAL_SORTABLE_ROWS.NAME) {
            this.filteredApps = this.filteredApps.sort((a, b) => this.alphaNumSort(a.name.toString(), b.name.toString())).reverse();
        } else {
            this.filteredApps = lodash.sortBy(this.filteredApps, sortBy, "type.val", GAL_SORTABLE_ROWS.NAME).reverse();
        }
        this.sortByCatUtil(false);

        if (this.sortAsc) {
            this.filteredApps.reverse();
        }
        this.setPaginatedRows();
        this.pager.changePage(1);
    }

    /**
     * For "category" sorting the TCITenantAppCategory must be
     * part of the applications array, so here that data is bound
     * to each app if "set" is TRUE and cleans it when FALSE
     */
    private sortByCatUtil(set: boolean) {
        this.filteredApps = this.filteredApps.map((app: any) => {
            if (set) { // Temporary category attribute
                app.category = TCITenantAppCategory.fromApplication(app).label;
            } else { // Remove temporary category attribute
                delete app.category;
            }
            return app;
        });
    }

    /**
     * </Sorting instructions>
     *
     * <Status Menu instructions>
     */
    statusMenuRouteHandling(routeId: string, appId: string) {
        this.statusMenuOptRouteId = routeId;
        delete this.statusMenuApp;
        delete this.statusMenuSelectedOption;
        delete this.statusMenuCmpInput;
        if (appId && this.statusMenuOptRouteId) {
            const statusMenuApp = this.apps.find(app => app.id === appId);
            if (statusMenuApp) {
                const preloadMap = statusMenuApp && this.tenantMenuSrv.getTenantPreloadMap(statusMenuApp.type);
                this
                    .tenantMenuSrv
                    .getAppDetailMenuItems(statusMenuApp.type, TCI_APP_DETAIL_MENU_TYPE.HAMBURGER_MENU)
                    .flatMap(menuItems => menuItems)
                    .filter((menuItem: ITCITenantComponentOptions<TCI_APP_DETAIL_MENU_TYPE>) =>
                        menuItem.getRouteId() === routeId)
                    .filter((menuItem: ITCITenantComponentOptions<TCI_APP_DETAIL_MENU_TYPE>) =>
                        menuItem.getComponentSelectorType().toString() in preloadMap)
                    .filter((menuItem: ITCITenantComponentOptions<TCI_APP_DETAIL_MENU_TYPE>) =>
                        lodash.isFunction(preloadMap[menuItem.getComponentSelectorType().toString()].inlineMenuHandlerFn))
                    .toArray()
                    .subscribe(
                        (menuItems: ITCITenantComponentOptions<TCI_APP_DETAIL_MENU_TYPE>[]) => {
                            if (menuItems.length === 0) {
                                this.statusMenuApp = statusMenuApp;
                            }
                            this.mountStatusMenuComponent();
                        }
                    );
            }
        }
    }

    navigateComponents(routeId?: string, appId?: string) {
        const params = ["applications", ...[routeId, appId].filter(p => p && p.toString().trim().length > 0)];
        this.router.navigate(params);
    }

    statusMenuCmpClose() {
        this.navigateComponents();
    }

    mountStatusMenuComponent() {
        if (this.statusMenuApp) {
            // Open the modal first
            this.createAppModalShow = false;

            // Prepare the modal dimensions
            this.statusMenuSelectedOption = TCITenantAppDetailsMenu.getAllMenuItems()
                .find(menu => menu.getRouteId() === this.statusMenuOptRouteId) as TCITenantAppDetailsMenu;

            const opts: ITCITenantCacheOptions = {
                routeId: TCIMainMenu.MAIN_MENU_APPLICATIONS.getRouteId(),
                subRouteId: TCIMainMenuSubroutes.TCI_APPLICATION_APP_LIST.getSubRouteId(),
                tenantType: this.statusMenuApp.type
            };

            this.subscriptions.push(
                this.cacheSvc.getCache(false, opts)
                    .flatMap(() => this.hmSvc.getAppMenuOptions(this.statusMenuApp, TCI_COMPONENT_MODE.COMP_MODE_APP_DETAIL_HAMBURGER_MENU))
                    .subscribe(appOpt => {
                        if (appOpt) {
                            const comp = appOpt.find(c => c.getRouteId() === this.statusMenuOptRouteId);
                            if (comp) {
                                this.statusMenuSelectedOption = comp;
                                this.statusMenuCmpInput = new BaseAppDetailMenuComponentInput(
                                    this.statusMenuApp.type,
                                    comp.getComponentSelectorType(),
                                    this.statusMenuApp,
                                    this.userService,
                                    this.featureToggleService,
                                    TCI_COMPONENT_MODE.COMP_MODE_APP_DETAIL_HAMBURGER_MENU,
                                    undefined,
                                    null
                                );
                            } else {
                                console.error("The requested component was not found", this.statusMenuApp, opts);
                            }
                        }
                    })
            );
        }
    }

    /**
     * </Status Menu instructions>
     *
     * <Local Storage instructions>
     * How it works:
     * On every type filtering, name filtering, sorting or page change that information is saved into local Storage.
     * After getting apps array the data is retreived and set on every one of the filter-related variables to initialize
     * the stage restoration. nameFilterCtrl filter activation is defined after that.
     * For pagination "pageRestoreValue" stores the page stage and is deleted after the restoration is completed.
     */
    storeGALstage() {
        if (!this.tagsFilterVisible) { // Avoid store if tags are not present yet
            return;
        }

        const filtersAndPagination: IStoredFilterAndPagination = {
            filter: {
                category: this.categoryFilter,
                deploymentCategory: this.appDeploymentCategoryFilter,
                statusCategory: this.appStatusCategoryFilter,
                name: this.nameFilterCtrl.value,
                owner: this.ownerFilter,
                tags: this.selectedTags
            },
            sort: {
                column: this.sortedBy,
                asc: this.sortAsc
            },
            page: this.pager ? this.pager.getPage() : 1
        };
        // console.warn("Storing >", filtersAndPagination);
        const localStorageKey = this.getGALPrefForUsr(this.ownerName);
        localStorage.setItem(localStorageKey, JSON.stringify(filtersAndPagination));
    }

    /**
     * </Local Storage instructions>
     *
     * <Hamburger Menu Output Handling>
     */
    private evaluateStatusMenuOutput($event: ITCIAppDetailsMenuOutput) {
        // console.log("Evaluating HMOutput", $event);
        if ($event.closeModal === true) {
            this.statusMenuCmpClose();
        }

        if ($event.refresh === true) {
            // For app copy and upload existing we need to refresh the applications list
            // Opened app peeks will get closed
            // TODO: maintain opened app peeks after refresh
            const reqApps = [
                TCITenantSelectorType.TCI_APP_DETAIL_COPY_APPLICATION,
                TCITenantSelectorType.TCI_APP_DETAIL_EDIT,
                TCITenantSelectorType.TCI_APP_DETAIL_RENAME_APPLICATION,
                TCITenantSelectorType.TCI_APP_DETAIL_UPLOAD_EXISTING_APP,
                TCITenantSelectorType.TCI_APP_DETAIL_TRANSFER_OWNERSHIP
            ].map(sel => sel.toString()).includes($event.menuItemSelector.toString());
            if (reqApps) {
                this.requestAppsAndTags();
            }

            // Trigger app change notifications
            this.appRefreshNotifSvc.evaluateHMOutput(this.statusMenuCmpInput.application, $event);
        }
    }

    /**
     * </Hamburger Menu Output Handling>
     */

    modalCenterCreateApp() {
        this.dialogCreateApp.center();
    }

    modalCenterDeleteApp() {
        this.dialogDeleteApp.center();
    }

    // Customizer
    private getCustomConfig(): Observable<ITCIAppCustomizationParam[]> {
        const appListCustomTypes = [
            this.CUSTOM_TYPES.APP_LIST_FILTERS,
            this.CUSTOM_TYPES.APP_LIST_FILTERS_APP_CATEGORY,
            this.CUSTOM_TYPES.APP_LIST_FILTERS_APP_OWNER,
            this.CUSTOM_TYPES.APP_LIST_FILTERS_DEPLOY_CATEGORY,
            this.CUSTOM_TYPES.APP_LIST_FILTERS_STATUS_CATEGORY,
            this.CUSTOM_TYPES.APP_LIST_FILTER_TAGS,
            this.CUSTOM_TYPES.APP_LIST_HEADER_MONITORING,
            this.CUSTOM_TYPES.APP_LIST_COL_CATEGORY,
            this.CUSTOM_TYPES.APP_LIST_COL_DEPLOYMENT,
            this.CUSTOM_TYPES.APP_LIST_COL_LAST_RUN,
            this.CUSTOM_TYPES.APP_LIST_COL_INSTANCES,
            this.CUSTOM_TYPES.APP_LIST_COL_STATUS,
            this.CUSTOM_TYPES.APP_LIST_COL_WIDTH,
            this.CUSTOM_TYPES.APP_LIST_ROW_PEEK_VIEW,
            this.CUSTOM_TYPES.APP_LIST_ROW_HAMBURGER,
            this.CUSTOM_TYPES.APP_CREATE,
            this.CUSTOM_TYPES.APP_LIST_PEEK_VIEW
        ];
        const customConfigObs: Observable<ITCIAppCustomizationParam>[] = appListCustomTypes.map(customType => {
            // Prepare observables to get the config of each type
            return this
                .customizationProviderService
                .getCustomizations({
                    type: customType
                })
                .map(custom => custom.success ? custom.result : null)
                .map((customParam: ITCIAppCustomizationParam) => {
                    if (customParam) {
                        this.customConfig[customType] = customParam;
                    }
                    return customParam;
                });
        });

        // Request the custom configuration
        return Observable.merge(...customConfigObs)
            .take(appListCustomTypes.length)
            .toArray();
    }

    private getCustomVisible(type: TCI_APP_CUSTOMIZATION_TYPE): boolean {
        const custom = this.customConfig[type];
        if (!custom) {
            return false;
        }
        return this.customConfig[type].enabled && this.customConfig[type].visible;
    }

    private getCustomLabel(type: TCI_APP_CUSTOMIZATION_TYPE): Observable<string> {
        const custom = this.customConfig[type];
        if (!custom || !custom.enabled || !custom.visible || !custom.label) {
            return this.translateSvc.get("APP_LIST.NEW_APP");
        }

        return Observable.of(custom.label);
    }

    // Monitoring header
    private getMonDashExpanForUsr(userId: string): string {
        return GAL_LOCAL_MONITOR_ITEM_PREFIX + CryptoJS.SHA256(GAL_LOCAL_MONITOR_ITEM + userId).toString();
    }

    // Local storage data
    private getGALPrefForUsr(userId: string): string {
        return GAL_LOCAL_ITEM_PREFIX + CryptoJS.SHA256(GAL_LOCAL_ITEM + userId).toString();
    }

    toggleMonitoring(setTranstion: boolean) {
        this.monitorPanelUseTransition = setTranstion;
        this.monitorPanelActive = !this.monitorPanelActive;
        if (this.monitorPanelActive) {
            this.monitorComponent.refresh();
        }

        // Store the expand state
        try {
            this.userService.getUserInfo()
                .subscribe(userInfo => {
                    const monUsrDashExpanded = this.getMonDashExpanForUsr(userInfo.userId);
                    if (this.monitorPanelActive) {
                        localStorage.setItem(monUsrDashExpanded, "1");
                    } else {
                        localStorage.removeItem(monUsrDashExpanded);
                    }
                });
        } catch (e) {
            console.warn("Could not set monitoring expand state", e);
        }
    }

    private restoreMonitoringExpandState(headerComponent?: NgAppListHeaderComponent) {
        if (headerComponent) {
            this.monitorComponent = headerComponent;
        }

        if (this.monitorPanelRestored || !this.monitorComponent || this.apps.length < 1) {
            return;
        }

        try {
            this.userService.getUserInfo()
                .subscribe(userInfo => {
                    const monUsrDashExpanded = this.getMonDashExpanForUsr(userInfo.userId);
                    const usrDataArrStr = localStorage.getItem(monUsrDashExpanded);
                    if (usrDataArrStr) {
                        this.toggleMonitoring(false);
                    }
                });
            this.monitorPanelRestored = true;
        } catch (e) {
            console.warn("Could not restore monitor expand state", e);
        }
    }

    private alphaNumSort(comparison1: string, comparison2: string) {
        return comparison1.localeCompare(comparison2, "en", { numeric: true, caseFirst: "upper" });
    }

    countAppsPerTag(): void {
        const appCountPerTag = this.tagsService.countAppsByTags(this.tagsList, this.apps);
        this.allAssetTags = this.tagsService.countTagsWithApps(this.allAssetTags, appCountPerTag);
        this.selectedTags = this.tagsService.countTagsWithApps(this.selectedTags, appCountPerTag);

        this.allAssetTagsCount = this.allAssetTags.filter(t => t.assetCount && t.assetCount > 0).length;
        this.selectedTagsCount = this.selectedTags.filter(t => t.assetCount && t.assetCount > 0).length;
    }

    changeTagsSelection(tags: ITCIAssetTag[]): void {
        if (!lodash.isEqual(tags, this.selectedTags)) {
            this.selectedTags = lodash.cloneDeep(tags);
            this.filterApps();
        }
    }

    // "requestTags" is the last step on building the applications list.
    // It is in charge of setting the flags for the template to render.
    private requestTags(tagsCollection?: ITCIAssetTagsList) {
        const finish = () => { // Set the flags ready and filter
            this.requestingApps = false;
            this.blockUiService.unblock();
            this.checkAppsExist();
            this.filterApps();
        };

        if (this.getCustomVisible(this.CUSTOM_TYPES.APP_LIST_FILTER_TAGS)) {
            const tagsObs: Observable<ITCIAssetTagsList> = !tagsCollection ?
                this.tagsService.getAllTags() : Observable.of(tagsCollection);

            tagsObs
                .map(tagsList => {
                    let storedSelectedTags: ITCIAssetTag[];
                    try {
                        const localStorageKey = this.getGALPrefForUsr(this.ownerName);
                        const GALstageData = localStorage.getItem(localStorageKey);
                        const GALstage: IStoredFilterAndPagination = JSON.parse(GALstageData);
                        storedSelectedTags = (GALstage && GALstage.filter ? GALstage.filter.tags : []) || [];
                    } catch (e) {
                        storedSelectedTags = [];
                    }

                    // Add the selected tags to the tags collection
                    for (const i in storedSelectedTags) {
                        if (!tagsList.tags.find(t => t.name === storedSelectedTags[i].name)) {
                            tagsList.tags.push({
                                id: null,
                                name: storedSelectedTags[i].name,
                                subscriptionId: null,
                                userName: null,
                                appIds: [],
                                connectionIds: [],
                                agentIds: []
                            });
                        }
                    }

                    this.allAssetTags = lodash.map(
                        Object.keys(this.tagsService.simplifyTagsList(tagsList)),
                        tagId => ({ name: tagId })
                    );

                    this.selectedTags = storedSelectedTags;
                    this.tagsList = tagsList;
                    this.tagsListSubject$.next(this.tagsList);
                    this.tagsFilterVisible = true;
                    return null;
                })
                .subscribe(() => {
                    this.tagsService.populateTagsToAssets(this.apps, this.tagsList);
                    finish();
                });
        } else if (this.apps) {
            finish();
        }
    }
}
